var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":function($event){return _vm.$emit('click:outer')}}},[_c('v-overlay',{attrs:{"value":_vm.open}})],1),_c('v-sheet',{style:(_vm.style)},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }